const domparser = new DOMParser()

/**
 * @param text
 *
 * decode('&lt; &gt; &quot; &apos; &amp; &#169; &#8710;');
 * // -> '< > " \' & © ∆'
 *
 * decode('&copy;', {level: 'html5'});
 * // -> '©'
 *
 * decode('&copy;', {level: 'xml'});
 * // -> '&copy;'
 */
export const decodeHtmlEntities = (text?: Maybe<string>): string => {
    return domparser.parseFromString(text ?? '', 'text/html')?.body?.textContent || ''
}
